"use client";

import { useCallback } from "react";
import { useHeaderCompactContext } from "./HeaderCompactContext";

/** Marks the top of page content — header compacts when this leaves the viewport (desktop). */
export function HeaderCompactSentinel() {
  const { registerSentinel } = useHeaderCompactContext();

  const handleRef = useCallback(
    (node: HTMLDivElement | null) => {
      registerSentinel(node);
    },
    [registerSentinel]
  );

  return (
    <div
      ref={handleRef}
      className="pointer-events-none h-px w-full shrink-0"
      aria-hidden
    />
  );
}
